import { render } from "./Agenda.vue?vue&type=template&id=50b2f588&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=50b2f588&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b2f588"]])

export default __exports__